import React from 'react';
import { ChevronRight, Star } from 'lucide-react';

const t = {
  en: {
    label: 'GET STARTED TODAY',
    title: 'READY TO BECOME WHO YOU SHOULD BE?',
    points: [
      'Science-based strength training',
      'Weekly new progression plans',
      'Measurable muscle building',
      'Calibrated to your level',
    ],
    cta: 'START LIFTING NOW',
  },
  de: {
    label: 'STARTE NOCH HEUTE',
    title: 'BEREIT ZU WERDEN, WER DU SEIN SOLLTEST?',
    points: [
      'Wissenschaftliches Krafttraining',
      'Wöchentlich neue Progressions-Pläne',
      'Messbarer Muskelaufbau',
      'Auf dein Level kalibriert',
    ],
    cta: 'JETZT DURCHSTARTEN',
  },
};

export default function FinalCTA({ lang }) {
  const tx = t[lang];

  return (
    <section
      className="py-28 px-6 relative overflow-hidden"
      style={{ backgroundColor: '#0f1117' }}
    >
      {/* Background grid */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(rgba(59,130,246,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(59,130,246,0.04) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      {/* Central glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{
          width: 700,
          height: 400,
          background: 'radial-gradient(ellipse, rgba(59,130,246,0.12) 0%, transparent 70%)',
        }}
      />

      <div className="max-w-4xl mx-auto relative z-10 text-center">
        <p
          className="text-sm font-bold uppercase mb-4"
          style={{ color: '#3b82f6', letterSpacing: '0.25em' }}
        >
          {tx.label}
        </p>

        <h2
          className="font-black uppercase leading-none mb-12"
          style={{
            fontSize: 'clamp(2.5rem, 8vw, 6rem)',
            letterSpacing: '-0.03em',
            color: '#ffffff',
          }}
        >
          {tx.title}
        </h2>

        {/* Points row */}
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-14">
          {tx.points.map((point, i) => (
            <div key={i} className="flex items-center gap-2">
              <Star
                size={14}
                fill="#3b82f6"
                color="#3b82f6"
              />
              <span
                className="font-semibold"
                style={{ color: '#94a3b8', fontSize: '0.95rem' }}
              >
                {point}
              </span>
            </div>
          ))}
        </div>

        {/* Big CTA */}
        <a
          href="/s"
          className="inline-flex items-center gap-4 px-10 py-5 rounded-xl font-black uppercase transition-all duration-200 hover:scale-105 group"
          style={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)',
            color: '#ffffff',
            letterSpacing: '0.15em',
            fontSize: '1.1rem',
            boxShadow: '0 0 60px rgba(59,130,246,0.5), 0 20px 40px rgba(0,0,0,0.4)',
          }}
        >
          {tx.cta}
          <ChevronRight size={22} className="transition-transform group-hover:translate-x-1" />
        </a>

        {/* Trust line */}
        <p
          className="mt-8 text-sm"
          style={{ color: '#334155' }}
        >
          {lang === 'de'
            ? 'Kein Vertrag. Jederzeit kündbar.'
            : 'No contract. Cancel anytime.'}
        </p>
      </div>
    </section>
  );
}
